import styled from 'styled-components'

export const DropZone = styled.div`
    border: 2px dashed #cccccc;
    border-radius: 6px;
    text-align: center;
    padding: 20px;
    margin: 20px 0;
`

export const Text = styled.p`
    margin: 0;
`
